var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Modal } from 'components/modal/Modal';
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Button } from 'components/Button';
import './ModalMewsPayment.scss';
/**
 * @component ModalMewsPayment
 * @since 1.0.0
 */
export function ModalMewsPayment(props) {
    var _a, _b;
    const { deal, onClose, dealPaymentId, currency = 'CAD' } = props;
    const containerRef = useRef(null);
    const [scriptLoaded, setScriptLoaded] = useState(false);
    const [error, setError] = useState(null);
    const activePayment = (_a = deal === null || deal === void 0 ? void 0 : deal.payments) === null || _a === void 0 ? void 0 : _a.find((p) => p.status === 'ACTIVE');
    const amount = (_b = activePayment === null || activePayment === void 0 ? void 0 : activePayment.amount) !== null && _b !== void 0 ? _b : 0;
    useEffect(() => {
        const existingScript = document.querySelector('script[src="https://app.mews-demo.com/payment-checkout/checkout.js"]');
        if (existingScript) {
            setScriptLoaded(true);
            return;
        }
        const script = document.createElement('script');
        script.src = 'https://app.mews-demo.com/payment-checkout/checkout.js';
        script.async = true;
        script.onload = () => setScriptLoaded(true);
        script.onerror = () => setError(t('Failed to load Mews Payment'));
        document.head.appendChild(script);
    }, []);
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f;
        const checkout = (_a = window.Mews) === null || _a === void 0 ? void 0 : _a.PaymentCheckout;
        if (!scriptLoaded || !checkout)
            return;
        const contact = deal === null || deal === void 0 ? void 0 : deal.contact;
        const billingLocation = (_b = deal === null || deal === void 0 ? void 0 : deal.billTo) !== null && _b !== void 0 ? _b : contact === null || contact === void 0 ? void 0 : contact.location;
        const payer = (contact === null || contact === void 0 ? void 0 : contact.lastname) && ((_c = contact === null || contact === void 0 ? void 0 : contact.primaryEmail) === null || _c === void 0 ? void 0 : _c.email)
            ? {
                details: Object.assign(Object.assign(Object.assign({ email: contact.primaryEmail.email, lastName: contact.lastname }, (contact.firstname && { firstName: contact.firstname })), (((_d = contact.primaryPhone) === null || _d === void 0 ? void 0 : _d.phone) && {
                    telephone: contact.primaryPhone.phone
                })), (billingLocation && {
                    address: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (billingLocation.civicNumber &&
                        billingLocation.road && {
                        addressLine1: `${billingLocation.civicNumber} ${billingLocation.road}`
                    })), (billingLocation.apartment && {
                        addressLine2: billingLocation.apartment
                    })), (billingLocation.city && { city: billingLocation.city })), (billingLocation.country && {
                        countryCode: billingLocation.country
                    })), (billingLocation.postalcode && {
                        postalCode: billingLocation.postalcode
                    }))
                }))
            }
            : undefined;
        checkout.load(Object.assign(Object.assign({ dataBaseUrl: process.env.MEWS_DATA_BASE_URL, containerId: 'mews-payment-checkout-container', context: {
                enterpriseId: (_e = deal === null || deal === void 0 ? void 0 : deal.paymentIntegration) === null || _e === void 0 ? void 0 : _e.enterpriseId,
                amount: {
                    // The Mews demo (set by the server, dev and staging) refuses CAD:
                    // EUR there, as the server expects when it checks the payment
                    currency: ((_f = deal === null || deal === void 0 ? void 0 : deal.paymentIntegration) === null || _f === void 0 ? void 0 : _f.checkoutBaseUrl)
                        ? 'EUR'
                        : currency,
                    value: amount
                }
            }, languageCode: 'en-US' }, (payer && { payer })), { onSuccess: (event) => __awaiter(this, void 0, void 0, function* () {
                // Only a charge means the money was taken.
                if ((event === null || event === void 0 ? void 0 : event.type) !== 'payment-charged' || !event.paymentId) {
                    return;
                }
                // The server verifies the payment in Mews before confirming the sale.
                const res = yield fetch(process.env.API_URL_ROOT +
                    '/mews-payment-complete?id=' +
                    dealPaymentId, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ paymentId: event.paymentId })
                }).catch(() => null);
                if (!(res === null || res === void 0 ? void 0 : res.ok)) {
                    setError(t('Your payment could not be confirmed. Please contact us before trying again.'));
                    return;
                }
                window.location.href = `/interactive-quote/${deal === null || deal === void 0 ? void 0 : deal.id}?paymentSuccess=true`;
            }), onFailure: (err) => {
                setError(t('Payment failed. Please try again.'));
                console.error('Mews payment failure:', err);
            } }));
    }, [scriptLoaded]);
    const footerActions = (React.createElement(Fragment, null,
        React.createElement(Button, { className: "button button--primary", onPress: onClose, label: t('Close') })));
    return (React.createElement("div", { className: "modal-mews-payment" },
        React.createElement(Modal, { title: t('Payment'), onClose: onClose, showFooterAction: true, footerActions: footerActions },
            React.createElement("div", { className: "modal-mews-payment-content" },
                error && React.createElement("p", { className: "modal-mews-payment-error" }, error),
                React.createElement("div", { id: "mews-payment-checkout-container", ref: containerRef, className: "modal-mews-payment-container" })))));
}
